import type JCE from '@chesscom/js-chess-engine';

/**
 * Gets the ids of the main line ancestor for a specific node
 */
export function getMainLineAncestorIds(
  ids: JCE.Ids | null | undefined,
  lines: JCE.Line[],
): JCE.Ids | null {
  if (!ids) {
    return null;
  }

  if (ids.line === 0) {
    return ids;
  }

  const line = lines[ids.line];

  // The most likely reason for this is that the node/line was deleted,
  // in which case we have no way of finding the main line ancestor.
  if (!line || line.parentId === undefined || line.atMoveNode === undefined) {
    return null;
  }

  // assumption: all lines eventually reach the main line and dont loop
  return getMainLineAncestorIds({ line: line.parentId, move: line.atMoveNode }, lines);
}
